var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalMall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_15803",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00976562,
    y: 0.68457,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_15803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99023 22.6846C4.44023 22.6846 3.9694 22.4887 3.57773 22.0971C3.18607 21.7054 2.99023 21.2346 2.99023 20.6846V8.68457C2.99023 8.13457 3.18607 7.66374 3.57773 7.27207C3.9694 6.8804 4.44023 6.68457 4.99023 6.68457H6.99023C6.99023 5.30124 7.47773 4.12207 8.45273 3.14707C9.42773 2.17207 10.6069 1.68457 11.9902 1.68457C13.3736 1.68457 14.5527 2.17207 15.5277 3.14707C16.5027 4.12207 16.9902 5.30124 16.9902 6.68457H18.9902C19.5402 6.68457 20.0111 6.8804 20.4027 7.27207C20.7944 7.66374 20.9902 8.13457 20.9902 8.68457V20.6846C20.9902 21.2346 20.7944 21.7054 20.4027 22.0971C20.0111 22.4887 19.5402 22.6846 18.9902 22.6846H4.99023ZM11.9902 14.6846C13.3736 14.6846 14.5527 14.1971 15.5277 13.2221C16.5027 12.2471 16.9902 11.0679 16.9902 9.68457H14.9902C14.9902 10.5179 14.6986 11.2262 14.1152 11.8096C13.5319 12.3929 12.8236 12.6846 11.9902 12.6846C11.1569 12.6846 10.4486 12.3929 9.86523 11.8096C9.2819 11.2262 8.99023 10.5179 8.99023 9.68457H6.99023C6.99023 11.0679 7.47773 12.2471 8.45273 13.2221C9.42773 14.1971 10.6069 14.6846 11.9902 14.6846ZM8.99023 6.68457H14.9902C14.9902 5.85124 14.6986 5.1429 14.1152 4.55957C13.5319 3.97624 12.8236 3.68457 11.9902 3.68457C11.1569 3.68457 10.4486 3.97624 9.86523 4.55957C9.2819 5.1429 8.99023 5.85124 8.99023 6.68457Z",
    fill: "#1C1B1F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalMall);
export default __webpack_public_path__ + "static/media/local_mall.a35235370aff05f15d28c691baeef0e0.svg";
export { ForwardRef as ReactComponent };